'use strict';

var core = require('./production/core');
var application = require('./application');
var constants = require('./constants');

module.exports = {
	core: core,
	application: application,
	constants: constants
};


// WEBPACK FOOTER //
// ../config/production.js